import { Injectable } from '@angular/core';

@Injectable()
export class Utilities {

	toast:any;

	constructor() {
    }

    addDisclaimerClassToBody() {
        this.addClassToBody('disclaimer-loaded');
    }

    addMapLoadedClassToBody() {
        this.addClassToBody('map-loaded');
    }

	addModalClassToBody() {
        this.addClassToBody('modal-bottom');
    }

    addClassToBody(className:string) {
        document.getElementsByTagName("body")[0].classList.add(className);
    }

    removeModalClassFromBody() {
        document.getElementsByTagName("body")[0].classList.remove('modal-bottom');
    }

    addLayerClass(layer:any, index:number, className:string) {
        layer.on("layerview-create", (event)=>{
            setTimeout(() => {
                this.resetLayerClass(index, className);
            }, 3000);
        });
    }

    resetLayerClass(index:number, className: string) {
        var classList = this.getClassListForIndex(index, className);
        if (classList) {
            classList.remove(className);
            setTimeout(() => {
                classList.add(className);
                },1);
        }
    }

    getClassListForIndex(index:number, attributeName?:string) {
        var selector = document.getElementsByClassName('esri-display-object');
        var element = null
		for(var i = 0; i < selector.length; i++) {
			if (i === index) {
                element = selector[i];
            }
            if (selector[i][attributeName]) {
                //sometimes the index gets shifted around, so we mark it with an attribute
                element = selector[i];
                return element.classList;
            }
        }
        if (element) {
        element[attributeName] = true;
            return element.classList;
        } else {
            return null;
        }
    }

}


// WEBPACK FOOTER //
// ./src/providers/utilities.ts